// Tiny CSV writer & file-download helper
function escapeCsv(v) {
  if (v == null) return "";
  const s = String(v);
  if (/[",\n]/.test(s)) return '"' + s.replace(/"/g, '""') + '"';
  return s;
}

export function buildCsv(headers, rows) {
  const head = headers.map(escapeCsv).join(",");
  const body = rows
    .map((r) => headers.map((h) => escapeCsv(r[h])).join(","))
    .join("\n");
  return head + "\n" + body;
}

export function downloadCsv(filename, csv) {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 200);
}
